/**
 * Só URLs absolutas http(s) viram <img>. O legado gravava placeholders em `picture_url`
 * (`default`, `default-ninght`) e o claim `picture` pode faltar: tudo isso é "sem foto".
 */
export function avatarUrl(value: string | null | undefined): string | null {
  const candidate = value?.trim()
  if (!candidate) return null
  try {
    const url = new URL(candidate)
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null
  } catch {
    return null
  }
}
